<script>
import { Line, mixins } from "vue-chartjs";
import { createAnimationOptions } from "../../../utils/chartAnimations";
const { reactiveProp } = mixins;

export default {
  name: "LineChartTemplate",
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    animationType: {
      type: String,
      default: 'smooth'
    }
  },
  methods: {
    renderLineChart: function () {
      // Используем настройки анимации из утилиты
      const animationOptions = createAnimationOptions(this.animationType, 'line');
      const animatedOptions = {
        ...this.options,
        ...animationOptions
      };

      this.renderChart(this.chartData, animatedOptions, {
        responsive: true,
        maintainAspectRatio: false,
      });
    },
  },
  watch: {
    data: function () {
      this.renderLineChart();
    },
  },
  mounted() {
    this.renderLineChart();
  },
}
</script>

<style scoped>

</style>